import React from "react";

import { useBreakpointValue } from "@whoosh/design-system/src/hooks/useBreakpointValue";

import { Patron } from "../../types";
import { PatronsListItem } from "../PatronsListItem";
import UnknownGuestCounter from "./UnknownGuestCounter.small";

type GuestListHeaderProps = {
  checkNewDisabled?: boolean;
  isDecrementDisabled?: boolean;
  isIncrementDisabled?: boolean;
  unknownGuestLimit?: number;
  unknownGuestCount: number;
  onAddUnknownGuest?: () => void;
  onRemoveUnknownGuest?: () => void;
  onCheckPlayer: (player: Patron, checked: boolean) => void;
  unknownGuestEnabled?: boolean;
  addedPatrons: Patron[];
};

export const GuestListHeader = ({
  checkNewDisabled,
  isDecrementDisabled,
  isIncrementDisabled,
  unknownGuestLimit,
  onAddUnknownGuest,
  unknownGuestCount,
  onRemoveUnknownGuest,
  onCheckPlayer,
  unknownGuestEnabled,
  addedPatrons,
}: GuestListHeaderProps) => {
  const addedPlayers =
    addedPatrons?.filter(
      (patron) => patron.type === "Guest" || patron.type === "New Guest"
    ) || [];

  const isMobileLayout = useBreakpointValue({
    base: true,
    xs: true,
    sm: true,
    md: false,
  });
  const currentlySelectedPlayers = addedPlayers.map((item) => {
    return (
      <PatronsListItem
        key={item.playerId}
        item={item}
        handleCheck={onCheckPlayer}
        checkNewDisabled={false}
        initiallyChecked={true}
      />
    );
  });

  return (
    <>
      {unknownGuestEnabled ? (
        <UnknownGuestCounter
          {...{
            checkNewDisabled,
            unknownGuestLimit,
            unknownGuestCount,
            onAddUnknownGuest,
            onRemoveUnknownGuest,
            isDecrementDisabled,
            isIncrementDisabled,
          }}
        />
      ) : null}
      {isMobileLayout && currentlySelectedPlayers}
    </>
  );
};
